import React from 'react';
import { OP_STATUS } from '../../../../../util/varibles/constants';
import styles from './style.module.scss';

interface IProps {
    status: OP_STATUS
    statusText: string
}
const Status: React.FC<IProps> = ({ status, statusText }) => {
    return <div className={styles['operation-status']} data-status={status}>
        {statusText}
    </div>
}

export default Status;
